import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const WaasSignUpReader = (props) => <AuthPageReader {...props} domainType="WAAS" pageKey="signUp" />;

export default WaasSignUpReader;
